/**
 * @generated SignedSource<<1d344bf6cdbb925f1af85cb2df367067>>
 * @relayHash 3d02e735d8d906c5c1121e6911f6b5f8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d02e735d8d906c5c1121e6911f6b5f8

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteTherapyPrescriptionInput = {
  id: string;
};
export type useDeDeleteTherapyPrescriptionMutation$variables = {
  input: De_deleteTherapyPrescriptionInput;
};
export type useDeDeleteTherapyPrescriptionMutation$data = {
  readonly de_deleteTherapyPrescription: {
    readonly de_TherapyPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useDeDeleteTherapyPrescriptionMutation = {
  response: useDeDeleteTherapyPrescriptionMutation$data;
  variables: useDeDeleteTherapyPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeDeleteTherapyPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteTherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "de_deleteTherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_TherapyPrescription",
            "kind": "LinkedField",
            "name": "de_TherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeDeleteTherapyPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteTherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "de_deleteTherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_TherapyPrescription",
            "kind": "LinkedField",
            "name": "de_TherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "3d02e735d8d906c5c1121e6911f6b5f8",
    "metadata": {},
    "name": "useDeDeleteTherapyPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0c0cfc5ed008a9e735cced9c594fed3b";

export default node;
